export const ErrorStatus = {
  DISTURBANCE: 406,
  MAINTENANCE: 503
};

export const ERROR_STATES = Object.values(ErrorStatus);

export default ErrorStatus;
